
























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class AssessmentOverviewCards extends Vue {
  @Prop({ type: Number, required: true }) notAdherentCount!: number;

  @Prop({ type: Number, required: true }) adherentCount!: number;

  @Prop({ type: Number, required: true }) inProgressCount!: number;
}

export default AssessmentOverviewCards;
